import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { Button, Modal, Spinner } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import styled from "styled-components";

import { ExternalLinkModalContext } from "@/App/context";

const TRANSLATION_PATH = "EXTERNAL_LINK_MODAL";

const StyledModal = styled(Modal)`
  &&.modal.wide {
    min-width: 20rem;
    max-width: 90vw; /* optional, if you want hard cap */
  }
`;

export const ExternalLinkModal = () => {
  const { isOpen, manualRedirectTo, close } = useContext(ExternalLinkModalContext);
  const { t: translate } = useTranslation();

  const handleClickManualRedirect = () => {
    if (typeof manualRedirectTo === "string") {
      window.open(manualRedirectTo);
    } else if (manualRedirectTo && typeof manualRedirectTo === "object") {
      const url = `${manualRedirectTo.pathname ?? ""}` + `${manualRedirectTo.search ?? ""}` + `${manualRedirectTo.hash ?? ""}`;
      window.open(url);
    }
    close();
  };

  return (
    <StyledModal visible={isOpen} size="wide">
      <Stack alignment="center">
        <Spinner />
        <Semibold>{translate(`${TRANSLATION_PATH}.openingExternalLink`)}</Semibold>
        <Body textAlign="center">{translate(`${TRANSLATION_PATH}.beingRedirected`)}</Body>
        <Body textAlign="center">
          <Button style={{ fontFamily: "Source Sans Pro", fontSize: "0.875rem" }} appearance="text" onClick={handleClickManualRedirect}>
            {translate(`${TRANSLATION_PATH}.clickHere`)}
          </Button>{" "}
          {translate(`${TRANSLATION_PATH}.ifYouArentRedirected`)}
        </Body>
      </Stack>
    </StyledModal>
  );
};
